import yaml from 'js-yaml';
import { DeviceType, ProfileType } from '@ixicare/resources';
import templateProFull from '../templates/config-template-pro-full.yaml?raw';
import templateProLtd from '../templates/config-template-pro-ltd.yaml?raw';
import templateLite from '../templates/config-template-lite.yaml?raw';
import { Schema } from '../schema';

const delay = (ms: number) => new Promise((r) => setTimeout(r, ms));

// Currently, Buttons vs Wearables have 1 difference in default value (heartbeat_period).
// Will ship with 1 schema for now, service wil dynamically generate it with the correct default.
const LITE_DEVICE_TYPES: ReadonlySet<DeviceType> = new Set([
  DeviceType.WALL_MOUNTED_DISTRESS_BUTTON,
  DeviceType.WRISTBAND_DISTRESS_BUTTON,
  DeviceType.IXI_LITE,
  DeviceType.IXI_TOUCH,
  DeviceType.IXI_BLACK,
]);

const cache = new Map<string, Schema>();

const pickTemplate = (profileType: ProfileType, deviceType: DeviceType): string => {
  if (LITE_DEVICE_TYPES.has(deviceType)) return templateLite;
  return profileType === ProfileType.Installer ? templateProLtd : templateProFull;
};

// TODO: Move to @ixicare/resources
export const getConfigSchema = async (profileType: ProfileType, deviceType: DeviceType): Promise<Schema> => {
  await delay(200);
  const key = `${deviceType}:${profileType}`;
  if (!cache.has(key)) {
    cache.set(key, yaml.load(pickTemplate(profileType, deviceType)) as Schema);
  }
  return cache.get(key)!;
};
